import { render, staticRenderFns } from "./22.vue?vue&type=template&id=510dfb08&scoped=true&"
import script from "./22.vue?vue&type=script&lang=js&"
export * from "./22.vue?vue&type=script&lang=js&"
import style0 from "./22.vue?vue&type=style&index=0&id=510dfb08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510dfb08",
  null
  
)

export default component.exports